<div class="fixed inset-0 z-60 bg-black/40 backdrop-blur-md overflow-y-auto">
    <div [ngClass]="{'animate-slide-in-right': !isClosing,'animate-slide-out-right': isClosing }"
        class="ml-auto min-h-screen w-full sm:w-[469px] bg-cover bg-center font-outfit text-white font-bold flex flex-col p-4 sm:pt-[25px] sm:px-[70px]"
        style="background-image: url('/images/side-menu/backgrounds/side-menu.svg');">
        <div class="text-right text-white text-xl cursor-pointer" (click)="hideMenu()">x</div>
        <div class="w-full flex justify-center mt-[50px]">
            <img src="/images/logo/semnexus.svg" alt="" />
        </div>
        <nav class="flex flex-col mt-[80px] gap-[50px] items-center text-3xl">
            <a (click)="hideMenu()" class="cursor-pointer" routerLink="/">home</a>
            <div class="flex flex-col items-center">
                <div class="flex flex-col items-center">
                    <div (click)="toggleDropdown('developmentServices')" class="flex items-center cursor-pointer">
                        <a>development services</a>
                        <img class="ml-3 relative top-[3px]" src="/images/side-menu/dropdown.svg" alt="" />
                    </div>
                    @if (dropdownStates['developmentServices'].show || dropdownStates['developmentServices'].animating)
                    {
                    <div class="mb-[30px] w-[330px]"
                        [ngClass]="{'animate-slide-down-up': !dropdownStates['developmentServices'].show,'animate-slide-up-down': dropdownStates['developmentServices'].show}"
                        (animationend)="onAnimationEnd('developmentServices')">
                        <nav class="flex flex-col gap-10 items-center text-center text-2xl mb-[30px]">
                            <a (click)="hideMenu()" routerLink="/app-development-company"
                                class="cursor-pointer border-b border-white/10 whitespace-nowrap w-[95%] sm:w-[400px] pb-[17px]">app
                                development</a>
                            <a (click)="hideMenu()" routerLink="/ai-automation-agency"
                                class="cursor-pointer border-b border-white/10 whitespace-nowrap w-[95%] sm:w-[400px] pb-[17px]">ai
                                automation</a>
                            <a (click)="hideMenu()" routerLink="/business-mobile-consulting"
                                class="cursor-pointer">mobile app strategy &amp; implementation</a>
                        </nav>
                        <div class="w-full flex justify-center mb-[30px]">
                            <div (click)="scheduleCall()"
                                class="relative inline-block w-[270px] h-[50px] rounded-[36px] cursor-pointer transition hover:scale-[1.04] hover:brightness-125 duration-300">
                                <img src="/images/button/border.svg" alt=""
                                    class="absolute inset-0 h-full w-full object-cover rounded-[36px]" />

                                <div
                                    class="relative z-10 w-full h-full flex items-center justify-center text-white font-outfit font-bold rounded-[36px]">
                                    <img class="mr-[9px] h-[18px] relative" src="/images/header/phone.svg"
                                        alt="Phone Icon" />
                                    <span class="text-[18px]">schedule a call</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    }
                </div>
            </div>
            <div class="flex flex-col items-center">
                <div class="flex flex-col items-center w-full">
                    <div (click)="toggleDropdown('marketingServices')" class="flex items-center cursor-pointer">
                        <a>marketing services</a>
                        <img class="ml-3 relative top-[3px]" src="/images/side-menu/dropdown.svg" alt="" />
                    </div>
                    @if (dropdownStates['marketingServices'].show || dropdownStates['marketingServices'].animating) {
                    <div class="mb-[30px] w-[330px]"
                        [ngClass]="{'animate-slide-down-up': !dropdownStates['marketingServices'].show,'animate-slide-up-down': dropdownStates['marketingServices'].show}"
                        (animationend)="onAnimationEnd('marketingServices')">
                        <nav class="flex flex-col gap-10 items-center text-center text-2xl mb-[30px]">
                            <a (click)="hideMenu()" routerLink="/aeo-marketing-services"
                                class="cursor-pointer border-b border-white/10 whitespace-nowrap w-[95%] sm:w-[400px] pb-[17px]">aeo
                                marketing</a>
                            <a (click)="hideMenu()" routerLink="/mobile-app-marketing-services"
                                class="cursor-pointer border-b border-white/10 whitespace-nowrap w-[95%] sm:w-[400px] pb-[17px]">app
                                marketing</a>
                            <a (click)="hideMenu()" routerLink="/apps-healthcare-marketing"
                                class="cursor-pointer border-b border-white/10 whitespace-nowrap w-[95%] sm:w-[400px] pb-[17px]">healthcare
                                marketing</a>
                            <a (click)="hideMenu()" routerLink="/influencer-process"
                                class="cursor-pointer border-b border-white/10 whitespace-nowrap w-[95%] sm:w-[400px] pb-[17px]">influencer
                                marketing</a>
                            <a (click)="hideMenu()" routerLink="/website-marketing-services"
                                class="cursor-pointer">website marketing</a>
                        </nav>
                        <div class="w-full flex justify-center mb-[30px]">
                            <div (click)="scheduleCall()"
                                class="relative inline-block w-[270px] h-[50px] rounded-[36px] cursor-pointer transition hover:scale-[1.04] hover:brightness-125 duration-300">
                                <img src="/images/button/border.svg" alt=""
                                    class="absolute inset-0 h-full w-full object-cover rounded-[36px]" />

                                <div
                                    class="relative z-10 w-full h-full flex items-center justify-center text-white font-outfit font-bold rounded-[36px]">
                                    <img class="mr-[9px] h-[18px] relative" src="/images/header/phone.svg"
                                        alt="Phone Icon" />
                                    <span class="text-[18px]">schedule a call</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    }
                </div>
            </div>
            <div class="flex flex-col items-center">
                <div class="flex flex-col items-center">
                    <div (click)="toggleDropdown('cases')" class="flex items-center cursor-pointer">
                        <a>case studies</a>
                        <img class="ml-3 relative top-[3px]" src="/images/side-menu/dropdown.svg" alt="" />
                    </div>
                    @if (dropdownStates['cases'].show || dropdownStates['cases'].animating) {
                    <div class="mb-[30px] w-[330px]"
                        [ngClass]="{'animate-slide-down-up': !dropdownStates['cases'].show,'animate-slide-up-down': dropdownStates['cases'].show}"
                        (animationend)="onAnimationEnd('cases')">
                        <nav class="flex flex-col gap-10 items-center text-center text-2xl mb-[30px]">
                            <a (click)="hideMenu()" routerLink="/development-case-studies"
                                class="cursor-pointer border-b border-white/10 whitespace-nowrap w-[95%] sm:w-[400px] pb-[17px]">development</a>
                            <a (click)="hideMenu()" routerLink="/marketing-case-studies"
                                class="cursor-pointer">marketing</a>
                        </nav>
                    </div>
                    }
                </div>
            </div>
            <a (click)="hideMenu()" class="cursor-pointer" href="/blog/">blog</a>
        </nav>
        <div class="w-full flex justify-center my-[70px]">
            <div (click)="scheduleCall()"
                class="relative inline-block w-[270px] h-[50px] rounded-[36px] cursor-pointer transition hover:scale-[1.04] hover:brightness-125 duration-300">
                <img src="/images/button/border.svg" alt=""
                    class="absolute inset-0 h-full w-full object-cover rounded-[36px]" />

                <div
                    class="relative z-10 w-full h-full flex items-center justify-center text-white font-outfit font-bold rounded-[36px]">
                    <img class="mr-[9px] h-[18px] relative" src="/images/header/phone.svg" alt="Phone Icon" />
                    <span class="text-[18px]">schedule a call</span>
                </div>
            </div>
        </div>
    </div>
</div>